<template lang="pug">
.form-customer.center(@click.stop="")
  .info-general-card
    .info-general-grid
      .info-general-item
        .info-general-icon
          span.material-symbols-outlined call
        .info-general-content
          .info-general-label Teléfono
          .info-general-value {{ dataOriginal.phone }}

      .info-general-item(v-if="dataOriginal.name")
        .info-general-icon
          span.material-symbols-outlined person
        .info-general-content
          .info-general-label Nombre
          .info-general-value.capitalize {{ dataOriginal.name }}

      .info-general-item(v-if="dataOriginal.email")
        .info-general-icon
          span.material-symbols-outlined email
        .info-general-content
          .info-general-label Correo
          .info-general-value {{ dataOriginal.email }}

      .info-general-item(v-if="dataOriginal.dni")
        .info-general-icon
          span.material-symbols-outlined badge
        .info-general-content
          .info-general-label DNI
          .info-general-value {{ dataOriginal.dni }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined toggle_on
        .info-general-content
          .info-general-label Estado
          .info-general-value {{ dataOriginal.active ? 'Activo' : 'Inactivo' }}

      .info-general-item
        .info-general-icon
          span.material-symbols-outlined calendar_today
        .info-general-content
          .info-general-label Registrado
          .info-general-value {{ dateName(dataOriginal.createdAt) }} - {{ time(dataOriginal.createdAt) }}

  div(v-if="dataOriginal.addresses && dataOriginal.addresses.length > 0")
    h3 Direcciones
    .addresses-container
      .address-item(v-for="address in dataOriginal.addresses" :key="address._id")
        .address-header
          span.material-symbols-outlined(v-if="address.isDefault") star
          span.material-symbols-outlined(v-else) location_on
          .address-alias.capitalize {{ address.alias || 'Dirección' }}
        .address-detail.capitalize {{ address.address }}
        .address-location.capitalize {{ address.location }} - {{ address.department }}
        .address-community.capitalize(v-if="address.community") {{ address.community }}

  .notification-section
    h3 Notificaciones de estado de orden

    .checkbox-section
      .input-container-checkbox
        label.label-checkbox(:for="`notifyEmail${dataOriginal.phone}`")
          span Email
          input.input-checkbox(v-model="notificationForm.email" :id="`notifyEmail${dataOriginal.phone}`" type="checkbox")
          .checkmark

    .checkbox-section
      .input-container-checkbox
        label.label-checkbox(:for="`notifyWhatsapp${dataOriginal.phone}`")
          span WhatsApp
          input.input-checkbox(v-model="notificationForm.whatsapp" :id="`notifyWhatsapp${dataOriginal.phone}`" type="checkbox")
          .checkmark

    .checkbox-section
      .input-container-checkbox
        label.label-checkbox(:for="`notifySms${dataOriginal.phone}`")
          span SMS
          input.input-checkbox(:checked="smsValue" :id="`notifySms${dataOriginal.phone}`" type="checkbox" disabled)
          .checkmark
        .notification-hint No editable por ahora

    shActionButton(
      v-if="hasNotificationChanges"
      :isForm="true"
      text="Actualizar"
      textRunning="Actualizando"
      :action="updateNotifications"
    )
</template>

<script>
import gql from '@my/graphql'
import gqlCustomer from '@/graphql/customer'
import modals from '@my/store/modals'
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'

const DEFAULT_PREFS = {
  email: true,
  whatsapp: true,
  sms: false
}

export default {
  name: 'FormCustomer',

  mixins: [mForm, mFilters],

  props: {
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      notificationForm: {
        email: DEFAULT_PREFS.email,
        whatsapp: DEFAULT_PREFS.whatsapp
      }
    }
  },

  watch: {
    dataOriginal: {
      immediate: true,
      handler () {
        this.syncNotificationForm()
      }
    }
  },

  methods: {
    resolvePrefs (customer) {
      const prefs = customer && customer.orderStatusNotifications
      return {
        email: prefs && typeof prefs.email === 'boolean' ? prefs.email : DEFAULT_PREFS.email,
        whatsapp: prefs && typeof prefs.whatsapp === 'boolean' ? prefs.whatsapp : DEFAULT_PREFS.whatsapp,
        sms: prefs && typeof prefs.sms === 'boolean' ? prefs.sms : DEFAULT_PREFS.sms
      }
    },

    syncNotificationForm () {
      const prefs = this.resolvePrefs(this.dataOriginal)
      this.notificationForm.email = prefs.email
      this.notificationForm.whatsapp = prefs.whatsapp
    },

    async updateNotifications () {
      if (!this.hasNotificationChanges) return

      this.showLoader(true)

      try {
        const response = await gql.mutate(gqlCustomer.UPDATE, {
          phone: this.dataOriginal.phone,
          customerUpdate: {
            orderStatusNotifications: {
              email: this.notificationForm.email,
              whatsapp: this.notificationForm.whatsapp
            }
          }
        })

        if (response && response.data && response.data.updateCustomer) {
          const updated = response.data.updateCustomer
          Object.assign(this.dataOriginal, updated)
          this.syncNotificationForm()
          modals.showMessage({ message: 'Preferencias de notificación actualizadas' })
        }
      } catch (error) {
        modals.showMessage({ message: 'No se pudieron actualizar las preferencias', type: 'error' })
      }

      this.showLoader(false)
    }
  },

  computed: {
    originalPrefs () {
      return this.resolvePrefs(this.dataOriginal)
    },

    smsValue () {
      return this.originalPrefs.sms
    },

    hasNotificationChanges () {
      return this.notificationForm.email !== this.originalPrefs.email ||
        this.notificationForm.whatsapp !== this.originalPrefs.whatsapp
    }
  }
}
</script>

<style lang="stylus">
.form-customer
  position relative

.addresses-container
  display flex
  flex-direction column
  gap 1em
  margin 1em 0

.address-item
  background white
  border-radius 0.8em
  padding 1.2em 1.5em
  border 1px solid rgba(0,0,0,0.08)

.address-header
  display flex
  align-items center
  gap 0.5em
  margin-bottom 0.5em
  font-weight 600

.address-alias
  font-size 1.05em

.address-detail
  color #555
  margin-bottom 0.2em

.address-location
  color #888
  font-size 0.9em

.address-community
  color #aaa
  font-size 0.85em

.notification-section
  margin-top 1.5em

.notification-section h3
  margin-bottom 0.75em

.notification-hint
  font-size 0.85em
  color #888
  margin 0.25em 0 0 0
</style>



// WEBPACK FOOTER //
// src/components/pages/customer/Form.vue